import styled from 'styled-components'
import { AddToTrolley } from '@sainsburys-tech/bolt'

const { Quantity } = AddToTrolley

export const QuantitySelector = styled(Quantity)`
  select {
    margin: 0 1px;
    padding: 11px 15px 12px;

    &:hover,
    &:active,
    &:focus {
      border-width: 1px;
      margin: 0 1px;
    }
  }

  ${({ isHidden }) =>
    isHidden &&
    `
    display: none;
  `}

  ${({ isTuTestVariant, theme }) =>
    isTuTestVariant &&
    `
    @media (max-width: ${theme.size.breakpoint['max-width'].sm}) {
      display: none;
    }
  `}
`

export const SelectSizePortalWrapperABTest = styled.div`
  display: none;

  ${({ isTuTestVariant, theme }) =>
    isTuTestVariant &&
    `
    @media (max-width: ${theme.size.breakpoint['max-width'].sm}) {
      display: block;

      #stickySizeSelector-portal {
        min-height: 58px;
        transform: translateY(-3px);
  }

    }
  `}
`
